<div class="row">
  <qa-grid-data [config]="config"></qa-grid-data>
</div>
